import { LiveFormType } from '@gen2/app/invites/send-invites/store';
import { noop } from 'lodash';
import { create } from 'zustand';

export interface FormModalStore {
  isCreateFormModalOpen: boolean;
  isNutrient: boolean;
  isInTemplates: boolean;
  fileId?: string;
  fileUrl?: string;
  liveFormType?: LiveFormType;
  openCreateFormModal: (
    fileId: string,
    isNutrient: boolean,
    handleOnSelected: (liveFormType: LiveFormType) => void,
    fileUrl?: string,
  ) => void;
  openTemplateCreateFormModal: (
    fileId: string,
    isNutrient: boolean,
    handleOnSelected: (liveFormType: LiveFormType) => void,
    fileUrl?: string,
  ) => void;
  closeCreateFormModal: () => void;
  handleOnSelected: (liveFormType: LiveFormType) => void;
  setFileUrl: (fileUrl: string) => void;
  setFileId: (fileId: string) => void;
  setLiveFormType: (liveFormType?: LiveFormType) => void;
  openViewerFileId?: string;
  openViewerIsNutrient?: boolean;
  openViewerType?: LiveFormType;
  setOpenViewer: (
    fileId?: string,
    isNutrient?: boolean,
    type?: LiveFormType,
  ) => void;
}

export const useFormModalStore = create<FormModalStore>()((set) => ({
  isCreateFormModalOpen: false,
  isNutrient: false,
  isInTemplates: false,
  fileId: undefined,
  fileUrl: undefined,
  liveFormType: undefined,
  openCreateFormModal: (
    fileId: string,
    isNutrient: boolean,
    handleOnSelected: (liveFormType: LiveFormType) => void,
    fileUrl?: string,
  ) =>
    set({
      isCreateFormModalOpen: true,
      fileId,
      fileUrl,
      isNutrient,
      isInTemplates: false,
      handleOnSelected,
    }),
  openTemplateCreateFormModal: (
    fileId: string,
    isNutrient: boolean,
    handleOnSelected: (liveFormType: LiveFormType) => void,
    fileUrl?: string,
  ) =>
    set({
      isCreateFormModalOpen: true,
      fileId,
      fileUrl,
      isNutrient,
      isInTemplates: true,
      handleOnSelected,
    }),
  closeCreateFormModal: () =>
    set({
      isCreateFormModalOpen: false,
      fileId: undefined,
      fileUrl: undefined,
      isNutrient: false,
      liveFormType: undefined,
      isInTemplates: false,
      handleOnSelected: noop,
    }),
  handleOnSelected: noop,
  setFileUrl: (fileUrl: string) => set({ fileUrl }),
  setFileId: (fileId: string) => set({ fileId }),
  setLiveFormType: (liveFormType?: LiveFormType) => set({ liveFormType }),
  openViewerFileId: undefined,
  openViewerIsNutrient: false,
  openViewerType: undefined,
  setOpenViewer: (fileId?: string, isNutrient?: boolean, type?: LiveFormType) =>
    set({
      openViewerFileId: fileId,
      openViewerIsNutrient: isNutrient,
      openViewerType: type,
    }),
}));
